// Shared validation helpers for investment declaration fields (employee + admin)

const INT32_MAX = 2147483647;

export const getNumberRangeError = (label, rawValue) => {
  if (rawValue === '' || rawValue == null) return '';
  const num = Number(rawValue);
  if (!Number.isFinite(num)) return `${label} must be a valid number`;
  if (num < 0) return `${label} cannot be negative`;
  if (num > INT32_MAX) return `${label} is too large (max ${INT32_MAX})`;
  return '';
};

export const getPanError = (label, rawValue) => {
  const v = (rawValue || '').toString().trim().toUpperCase();
  if (!v) return '';
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(v) ? '' : `Please enter a valid ${label} (e.g., ABCDE1234F)`;
};

export const getAddressError = (label, rawValue) => {
  const v = (rawValue || '').toString().trim();
  if (!v) return '';
  if (v.length < 3) return `${label} is too short`;
  return '';
};
